import { ADD_UPDATE_JURY_BRIEFING_ACTION_TYPE, GET_ADMIN_APPLICATION_LIST_ACTION_TYPE, GET_ADMIN_APPLICATION_MATRIX_LIST_ACTION_TYPE, GET_ADMIN_DASHBOARD_LIST_ACTION_TYPE, GET_ADMIN_JURY_BRIEFING_LIST_ACTION_TYPE, GET_APPLICATION_QUERY_LIST_ACTION_TYPE, INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING_ACTION_TYPE, VERIFY_APPLICATION_ACTION_TYPE } from "../../utils/constants";

const initialState = [];
function adminModuleReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ADMIN_APPLICATION_LIST_ACTION_TYPE:
      return [...state, payload];
    case VERIFY_APPLICATION_ACTION_TYPE:
      return [...state, payload];
    case GET_ADMIN_APPLICATION_MATRIX_LIST_ACTION_TYPE:
      return [...state, payload];
    case GET_ADMIN_JURY_BRIEFING_LIST_ACTION_TYPE:
      return [...state, payload];
    case ADD_UPDATE_JURY_BRIEFING_ACTION_TYPE:
      return [...state, payload];
    case GET_APPLICATION_QUERY_LIST_ACTION_TYPE:
      return [...state, payload];
    case INSERT_UPDATE_APPLICATION_FORM_SUVIN_SCORING_ACTION_TYPE:
      return [...state, payload];

    default:
      return state;
  }
}
export default adminModuleReducer;
